import React from 'react'

const SvgCutleryFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M6 21a.977.977 0 01-.009.175A.96.96 0 014.083 21l.734-8.01c.048-.513-.37-.993-.817-1.353C3.517 11.248 3 11 3 11c0-1.75.5-4 1-5.812a49.042 49.042 0 01.864-2.8A.586.586 0 016 2.586V21zM11.5 10l-.458 11a.96.96 0 101.917 0L12.5 10a3.972 3.972 0 001.03-.7C14.334 8.567 15 7.485 15 6.5c0-1.767-.75-4.5-3-4.5S9 4.733 9 6.5c0 .985.667 2.067 1.47 2.8.332.304.688.548 1.03.7zM17 6.5c0 1.392.835 2.48 2 3L18.542 21a.96.96 0 101.916 0L20 9.5c1.165-.52 2-1.607 2-3v-4a.5.5 0 00-1 0v4h-1v-4a.5.5 0 00-1 0v4h-1v-4a.5.5 0 00-1 0v4z' />
  </svg>
)

export default SvgCutleryFilled
